import React        from 'react';
import PropTypes    from 'prop-types';
import Dropdown     from './NavbarGuestMenuDropdown';
import Translations from '../../utils/Translations';

class NavbarGuestMenu extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		// Dropdown menu (don't render menu on server!)
		const dropdown = (
			<Dropdown
				guestName={this.props.guestName}
				initialGuestBalanceFormatted={this.props.guestBalanceFormatted}
				guestUrlPreviewPicture={this.props.guestUrlPreviewPicture}
				myVisitXUrl={this.props.myVisitXUrl}
				myVisitXGuestProfileUrl={this.props.myVisitXGuestProfileUrl}
				myVisitXGuestFavoriteActorsUrl={this.props.myVisitXGuestFavoriteActorsUrl}
				vipClubUrl={this.props.vipClubUrl}
				privateCollection={this.props.privateCollection}
			/>
		);

		return (
			<div className={"navigation__link" + (this.props.isSelected ? ' is-active' : '')}>
				<a href="#"
					/*ref={mountHandler}*/
                   data-toggle="dropdown"
                   className="js-dropdown-toggle navigation__link"
                   role="button"
                   aria-haspopup="true"
                   aria-expanded="false"
                   data-tooltip-id="tooltip-bottom"
                   data-tooltip-content={Translations.get('NavbarUserMenuTooltip')}
				>
					<i className="navigation__icon -icon-user-full" /><span className="navigation__label">{Translations.get('NavbarGuestMenuLabel')}</span>
				</a>
				{dropdown}
			</div>
		);
	}
}

NavbarGuestMenu.propTypes = {
	guestName:                      PropTypes.string,
	guestBalanceFormatted:          PropTypes.string,
	guestUrlPreviewPicture:         PropTypes.string,
	myVisitXUrl:                    PropTypes.string,
	myVisitXGuestProfileUrl:        PropTypes.string,
	myVisitXGuestFavoriteActorsUrl: PropTypes.string,
	vipClubUrl:                     PropTypes.string,
	privateCollection:              PropTypes.string,
	isSelected:                     PropTypes.bool,
};

export default NavbarGuestMenu;
